<div style="margin-top: 10px;">
  <form [formGroup]="commodityForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Commodity
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
            <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" >
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Commodity Name</span>
                    <input placeholder="Search by Name" type="search" matInput
                      autocomplete="off" formControlName="name" class="mat-input-custom">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.name}}</td>
                </ng-container>
                <ng-container matColumnDef="commodityType">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>Commodity Type</span>
                      <mat-select formControlName="commodityType" placeholder="Search by Type">
                        @for (commodityType of commodityTypes; track commodityType) {
                          <mat-option [value]="commodityType.key">
                            {{commodityType.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.commodityType}}</td>
                </ng-container>
                <ng-container matColumnDef="hsCode">
                  <th mat-header-cell *matHeaderCellDef class="header">
                    <div class="sorting_header">
                      <span mat-sort-header>HS Code</span>
                      <input placeholder="Search by HS Code" type="search" matInput
                        autocomplete="off" formControlName="hsCode" class="mat-input-custom">
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.hsCode}}</td>
                  </ng-container>
                  <ng-container matColumnDef="commodityGroup">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>Commodity Group</span>
                        <mat-select formControlName="commodityGroup" placeholder="Search by Group">
                          @for (commodityGroup of commodityGroups; track commodityGroup) {
                            <mat-option [value]="commodityGroup.key">
                              {{commodityGroup.label}}
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align:center;">{{element.commodityGroup || "----"}} </td>
                  </ng-container>
                  <ng-container matColumnDef="imdgClass">
                    <th mat-header-cell *matHeaderCellDef class="header">
                      <div class="sorting_header">
                        <span mat-sort-header>IMDG Class</span>
                        <input placeholder="Search by Class" type="search" matInput
                          autocomplete="off" formControlName="imdgClass" class="mat-input-custom">
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let element" style="text-align:center;">{{element.imdgClass || "----"}}</td>
                    </ng-container>
                    <ng-container matColumnDef="imdgClassName">
                      <th mat-header-cell *matHeaderCellDef class="header">
                        <div class="sorting_header">
                          <span mat-sort-header>IMDG Class Name</span>
                          <input placeholder="Search by Class Name" type="search" matInput
                            autocomplete="off" formControlName="imdgClassName" class="mat-input-custom">
                          </div>
                        </th>
                        <td mat-cell *matCellDef="let element" style="text-align:center;">{{element.imdgClassName || "----"}}</td>
                      </ng-container>
                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="header">
                          <span mat-sort-header>Action</span></th>
                          <td mat-cell *matCellDef="let element">
                            <span class="__action_edit_icon" (click)="openForm(element)">
                              <mat-icon mat-cell>create</mat-icon>
                            </span>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="groupColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
                      </table>
                    </div>
                  }
                </mat-card-content>
              </mat-card>
              @if (viewPermission) {
                <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalRecords"></mat-paginator>
              }
            </form>
          </div>